var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "single-image-upload" },
    [
      _vm.currentValue
        ? [
            _c(
              "div",
              {
                staticClass: "preview-wrap",
                style: _vm.previewWrapStyle,
                on: {
                  mouseenter: function ($event) {
                    _vm.hoverPreview = true
                  },
                  mouseleave: function ($event) {
                    _vm.hoverPreview = false
                  },
                },
              },
              [
                _c("img", {
                  staticClass: "icon-preview",
                  attrs: { src: _vm.currentValue, alt: _vm.tip },
                }),
                _c(
                  "div",
                  {
                    staticClass: "preview-mask",
                    class: { visible: _vm.hoverPreview },
                  },
                  [
                    _c("i", {
                      staticClass: "el-icon-delete remove-icon",
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.handleRemove.apply(null, arguments)
                        },
                      },
                    }),
                  ]
                ),
              ]
            ),
          ]
        : _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.uploading,
                  expression: "uploading",
                },
              ],
              staticClass: "uploader-wrap",
              style: _vm.uploaderStyle,
              attrs: { "element-loading-text": "上传中" },
            },
            [
              _c(
                "el-upload",
                {
                  staticClass: "icon-uploader",
                  style: _vm.uploaderStyle,
                  attrs: {
                    "show-file-list": false,
                    "http-request": _vm.handleUpload,
                    "before-upload": _vm.beforeUpload,
                    accept: _vm.fileTypes.join(","),
                    action: "#",
                    disabled: _vm.uploading,
                  },
                },
                [_c("i", { staticClass: "el-icon-plus icon-uploader-icon" })]
              ),
            ],
            1
          ),
      _vm.tip
        ? _c("div", { staticClass: "upload-tip" }, [_vm._v(_vm._s(_vm.tip))])
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }